import React from "react"
import useLocationsStore from "../Stores/locationsStore"
import { Location } from "../Models/LocationListResponse"

interface LocationCardProps {
  location: Location
  isSelected: boolean
  onSelect: (location: Location) => void
}

const LocationCard: React.FC<LocationCardProps> = ({
  location,
  isSelected,
  onSelect
}) => {
  return (
    <div
      className={`card h-100 ${isSelected ? "border-primary" : ""}`}
      onClick={() => onSelect(location)}
      style={{ cursor: "pointer" }}
    >
      <div className="position-relative">
        {location.miniPhotoUrl ? (
          <img
            src={location.miniPhotoUrl}
            className="card-img-top"
            alt={location.name}
            style={{ height: "200px", objectFit: "cover" }}
          />
        ) : (
          <div className="bg-secondary" style={{ height: "200px" }} />
        )}
        <div className="position-absolute top-0 end-0 m-2">
          <span className="badge bg-dark">{location.type}</span>
        </div>
      </div>
      <div className="card-body">
        <h5 className="card-title">{location.name}</h5>
      </div>
    </div>
  )
}

const LocationsList: React.FC = () => {
  const { locations, countryNames, loading, error, setTargetLocationId } =
    useLocationsStore()
  const [selectedLocationId, setSelectedLocationId] = React.useState<
    string | null
  >(null)

  const handleLocationSelect = (location: Location) => {
    setSelectedLocationId(location.id)
    setTargetLocationId(location.id)
    // Add any additional selection logic here
  }

  if (loading) {
    return (
      <div className="container py-4">
        <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
          {[...Array(6)].map((_, index) => (
            <div key={index} className="col">
              <div className="card">
                <div className="placeholder-glow">
                  <div className="placeholder" style={{ height: "200px" }} />
                </div>
                <div className="card-body">
                  <div className="placeholder-glow">
                    <span className="placeholder col-6"></span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="container py-4">
        <div className="alert alert-danger" role="alert">
          {error}
        </div>
      </div>
    )
  }

  if (locations.length === 0) {
    return (
      <div className="container py-4">
        <div className="alert alert-info" role="alert">
          No locations found
        </div>
      </div>
    )
  }

  return (
    <div className="container py-4">
      <h2 className="mb-4">
        {countryNames ? `Top locations in ${countryNames}` : "Top Locations"}
      </h2>
      <div className="row row-cols-1 row-cols-md-1 row-cols-lg-1 row-cols-xl-2 g-4">
        {locations.map(location => (
          <div key={location.id} className="col">
            <LocationCard
              location={location}
              isSelected={location.id === selectedLocationId}
              onSelect={handleLocationSelect}
            />
          </div>
        ))}
      </div>
    </div>
  )
}

export default LocationsList
